/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfStreetDto } from '../../models/paginated-dto-of-street-dto';

export interface GetStreets$Params {
  name?: string;
  limit?: number;
  settlementId: string;
}

export function getStreets(http: HttpClient, rootUrl: string, params: GetStreets$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfStreetDto>> {
  const rb = new RequestBuilder(rootUrl, getStreets.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('limit', params.limit, {});
    rb.query('settlementId', params.settlementId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfStreetDto>;
    })
  );
}

getStreets.PATH = '/api/v1/streets';
